import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';
import App from '../App';

class KeyValueAPI {

  static Integer = 1;
  static Text = 2;
  static JSON = 3;

  static list = (keys, success, failure) => {
    fetch(Config.app.link + 'api/key-val/list', new Header('POST', keys))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (key, success, failure) => {
    fetch(Config.app.link + 'api/key-val/' + key, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (key, type, value, success, failure) => {
    const body = { key, type, value };
    fetch(Config.app.link + 'api/key-val/' + key, new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => App.onFail(er));
  }
}
export default KeyValueAPI;